import { Injectable } from '@angular/core';

@Injectable()
export class WeblinkTokenService {

  constructor() { }

}
